// extracted by mini-css-extract-plugin
module.exports = {"selectionBlock":"styles_selectionBlock__z9Pya","buttons":"styles_buttons__JgV5H","imgContainer":"styles_imgContainer__RLohM","showCategories":"styles_showCategories__3kAgr"};